import { render, staticRenderFns } from "./AppBuyLayer.vue?vue&type=template&id=6fe0e0fa&"
import script from "./AppBuyLayer.vue?vue&type=script&lang=js&"
export * from "./AppBuyLayer.vue?vue&type=script&lang=js&"
import style0 from "./AppBuyLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports